/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Tabs, Table, Button, Progress, Popover } from 'antd';
import { GetIcon } from 'datastake-daf/dist/components';
import { isClient } from '../../../../routes/ModuleRouter';
import { generatePath } from 'react-router-dom';
import { ArrowLeftOutlined, EditOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import moment from 'moment';
import RiskService from '../../../../services/RiskService';

import { repeatObjects, showHideInput } from '../../helper';
import RiskProfile from '../components/risk/riskProfile';
import RiskScore from '../components/risk/riskScore';
import IncidentTimeline from '../components/risk/incidentTimeline';
import i18next from 'i18next';
import RiskTrend from '../components/risk/riskTrend';
import { getInputLabel } from '../../../Edit/helper';
import { connect } from 'react-redux';
import { getLabels } from '../../../../helpers/useRiskGauge';
import SubGroupView from '../components/risk/subGroupView';
import { PROJECTS } from '../../../../helpers/CanAccess';
import useQuery from '../../../../helpers/useQuery';
import { formPaths } from '../../../../helpers/form';
import { getSourceName } from '../../../../helpers/user';
import { getLocales } from '../../../../components/Table/newTable';
import { useTranslation } from 'react-i18next';

const iconBackgroundColors = [
  'transparent',
  'rgba(115, 209, 61, 0.05)',
  'rgba(250, 219, 20, 0.05)',
  'rgba(250, 140, 22, 0.05)',
  'rgba(255, 77, 79, 0.05)',
  'rgba(207, 19, 34, 0.05)',
];

function RiskComponent({
  conf: {
    form,
    data: initData,
    linkingForms,
    linkingData,
    match,
    allData,
    mod = 'pme',
    canEdit,
    mode = 'app',
  },
  user,
  location,
  project: { data: { projects }, sources = [] },
  authentication: { selectedProject },
}) {
  const { t } = useTranslation();
  const params = useQuery();
  const [projectData, setProjectData] = useState(null);
  const [sourceId, setSourceId] = useState(params.get('sourceId') || localStorage.getItem('source') || null);

  const data = useMemo(() => {
    if (initData && form) {
      return Object.keys(initData).reduce((all, key) => {
        const forms = form[key].forms;
        const formsKeys = Object.keys(forms);
        const formData = formsKeys.map(k => {
          const foundValue = initData[key].find(v => v.subCategory === k);
          return foundValue || {
            id: k,
            components: {},
            config: [],
            connectedEvents: {},
            category: key,
            score: 0,
            subCategory: k,
          };
        });
        all[key] = formData;
        return all;
      }, {});
    }

    return {};
  }, [initData, form]);


  useEffect(() => {
    if (selectedProject === 'myOwnData') {
      localStorage.removeItem('source');
      if (user && user.company) {
        setSourceId(user?.company?.id);
      }
    } else {
      if (sourceId) {
        localStorage.setItem('source', sourceId);
      }
    }
  }, [selectedProject]);

  const participantOrgName = useMemo(() => {
    const s = sourceId || localStorage.getItem('source');
    if (projectData && s) {
      const participant = sources.find((p) => p.authorId === s);
      if (participant) {
        return getSourceName(participant);
      }
    }
    return null;
  }, [sourceId, projectData, sources]);

  useEffect(() => {
    if (projects && projects.length && selectedProject) {
      const pData = projects.find(p => p.id === selectedProject);
      setProjectData(pData);
      if (projectData && projectData.id !== selectedProject && pData) {
        const sources = pData.sources.map(s => s.userId);
        if (sources[0]) {
          setSourceId(sources[0])
          localStorage.setItem('source', sources[0]);
        }
      }
    }
  }, [projects, selectedProject]);

  const [linkedEvents, setLinkedEvents] = useState([]);
  const [loadingLinkedEvents, setLoadingLinkedEvents] = useState(true);
  const { position, label, showFormIf, template, excludeFromEdit, ...allSubSections } = form;
  const goTo = useNavigate();
  const container = useRef();
  const { pathname } = useLocation();
  const { group, subsection, subgroup, id } = useParams();
  const colors = {
    5: '#CF1322',
    4: '#FF4D4F',
    3: '#FA8C16',
    2: '#FADB14',
    1: '#73D13D',
    0: '#F1F1F1'
  }

  useEffect(() => {
    if (params.get('sourceId')) {
      setSourceId(params.get('sourceId'));
    }
  }, [])

  const push = (url) => {
    const sId = params.get('sourceId');
    goTo(url);

    if (sId) {
      goTo(`${url}?sourceId=${sId}`)
    }
  }

  const filterSubSections = () => {
    return Object.keys(allSubSections).reduce((all, key) => {
      const section = allSubSections[key];
      if (section.showFormIf) {
        const show = showHideInput(
          { ...section, showIf: section.showFormIf },
          allData,
        );
        if (!show) {
          return all;
        }
      }
      all[key] = section;
      return all;
    }, {});
  };

  const subSections = filterSubSections();

  useEffect(() => {
    if (!subsection && group === 'risk') {
      const params = { ...match.params, subsection: Object.keys(subSections)[0] };
      push(generatePath(formPaths.view(mod), params));
    }
  }, [subsection])

  useEffect(() => {
    if (container && container.current) {
      container.current.scrollTo(0, 0);
    }
  }, [subgroup])

  const scoreToLabel = (score) => {
    score = Math.round(score);
    const labels = {
      5: i18next.t('Very High'),
      4: i18next.t('High'),
      3: i18next.t('Medium'),
      2: i18next.t('Low'),
      1: i18next.t('Very Low'),
    }
    return <div className="riskLevel" style={{ color: colors[score] }}>
      <div className="cont icon" style={{ background: iconBackgroundColors[score] }}>
        <GetIcon icon="flag" type="fill" size="2x" />
      </div>
      <div className="cont">
        {labels[score]}
      </div>
    </div>
  }

  const riskComponent = (value, parent, key, language) => {
    const config = form[parent].inputs[key];
    const breakpoints = {
      5: 100,
      4: 75,
      3: 50,
      2: 35,
      1: 20,
    }
    return <div className="riskComponents">
      {repeatObjects(config.inputs, (iKey) => {
        const label = config.inputs[iKey].label;
        return <div className="component">
          <p>{label[language] || label.en}: {value[iKey]}</p>
          <Progress
            showInfo={false}
            percent={breakpoints[value[iKey]]}
            size="small"
            strokeColor={colors[value[iKey]]} />
        </div>
      })}
    </div>;
  }
  const checkIfDisabled = (f, inputValue) => {
    let isDisabled = false;
    if (f.inputs && f.inputs.subCategory && f.inputs.subCategory.options) {
      const o = f.inputs.subCategory.options
        .find(item => item.value === inputValue);
      isDisabled = (o || {}).disabled;
    }
    return isDisabled;
  }

  const trendIcons = {
    up: 'ArrowUpOutlined',
    down: 'ArrowDownOutlined',
    equal: 'PauseOutlined'
  };
  const getColRender = (type, parent, key) => {
    return (value, row) => {
      let inputValue = value;
      const isDisabled = checkIfDisabled(form[parent], row.subCategory);
      if (form[parent].inputs[key].options) {
        const item = form[parent].inputs[key].options
          .find(item => item.value === inputValue);
        const label = item ? item.label : '';
        inputValue = label;
      }
      let definition;
      if (form[parent]) {
        if (form[parent].forms) {
          if (form[parent].forms[value]) {
            if (form[parent].forms[value].definition) {
              definition = form[parent].forms[value].definition;
            }
          }
        }
      }
      switch (type) {
        case 'text':
          return !isDisabled ? inputValue : null;
        case 'link':
          return isDisabled ? <span className="risk-disabled">{inputValue}</span> : <a
            style={{ color: 'var(--mmt-primary-70)' }}
            onClick={() => {
              const params = { ...match.params, subsection: parent, subgroup: value };
              push(generatePath(formPaths.view(mod), params));
            }}>
            {inputValue}
            {definition && (
              <Popover
                content={<div style={{ maxWidth: 300 }}>{definition}</div>}
              >
                <InfoCircleOutlined style={{ marginLeft: 6 }} />
              </Popover>
            )}
          </a>
        case 'scoreToLabel':
          return !isDisabled ? scoreToLabel(value, parent, key) : null;
        case 'riskComponent':
          return !isDisabled ? riskComponent(value, parent, key, user.language) : <span className="risk-disabled-intro">
            <span className="round-icon"><GetIcon icon="lock" type="fill" /></span>{i18next.t("This risk score is disabled")}
          </span>;
        case 'trend':
          const props = {
            up: {
              style: { fontSize: 'var(--size-lg)' }
            },
            down: {
              style: { fontSize: 'var(--size-lg)' }
            },
            equal: {
              rotate: 90,
              style: { fontSize: 'var(--size-lg)' }
            }
          }
          return !isDisabled && trendIcons[value] ? <span className="text-center d-flex justify-content-center"><GetIcon icon={trendIcons[value]} {...props[value]} /></span> : null
        default:
      }
    }
  }

  const getEditLink = () => {
    // eslint-disable-next-line no-useless-escape
    const r = new RegExp(`\/view\/`);
    const [previous, extra] = pathname.split(r);
    return `${previous}/edit/${extra}`;
  }
  const getCols = (key) => {
    const rInputs = subSections[key].inputs || {};
    const cols = Object.keys(rInputs).reduce((allCols, iKey) => {
      const title = rInputs[iKey].outputLabel
        || rInputs[iKey].label;
      const type = rInputs[iKey].viewInputType
        || rInputs[iKey].inputType
      allCols.push({
        title,
        dataIndex: iKey,
        render: getColRender(type, key, iKey)
      });
      return allCols;
    }, []);

    const canEdit = selectedProject === PROJECTS.myData;

    cols.push({
      title: '',
      fixed: 'right',
      render: (value, row) => {
        const isDisabled = checkIfDisabled(form[key], row.subCategory)
        return (
          <div style={{ textAlign: 'end' }} className='flex'>
            <Button
              disabled={isDisabled}
              type="link"
              onClick={() => {
                const params = { ...match.params, subsection: key, subgroup: value.subCategory };
                push(generatePath(formPaths.view(mod), params));
              }}
              icon={<GetIcon icon="eye" type="line" size="1x" style={{ marginRight: '4px' }} />}>
              {i18next.t('View')}
            </Button>
            {!isClient(user) && canEdit ? <Button
              disabled={isDisabled}
              type="link"
              onClick={() => {
                const path = getEditLink();
                push(`${path}/${value.subCategory}/identification`)
              }}
              icon={<EditOutlined size={14} style={{ marginRight: '4px' }} />}>
              {i18next.t('Edit')}
            </Button> : null}
          </div>
        )
      }
    });
    return cols;
  }

  const getSubGroupTitle = () => {
    const option = subSections[subsection].inputs.subCategory.options
      .find(item => item.value === subgroup);
    return option ? option.label : 'Not Found'
  }

  const getTotalScore = () => {
    let totalRisks = 0;
    let risksWithScore = 0;
    let totalScore = 0;
    Object.keys(subSections).forEach((key) => {
      let totalScores = 0;
      let allScores = 0;
      const total = !data[key] ? 0 : data[key].reduce((a, b) => {
        allScores += 1;
        if (b.score) {
          totalScores += 1;
          return a + b.score;
        }
        return a;
      }, 0);
      totalRisks += allScores;
      risksWithScore += totalScores;
      totalScore += total;
    });
    return {
      totalRisks,
      score: totalScore ? parseFloat((totalScore / risksWithScore).toFixed(2)) : 0,
      risksWithScore
    };
  }

  const getRiskProfiles = () => {
    let i = 0;
    return Object.keys(subSections).reduce((items, key) => {
      let totalScores = 0;
      const total = !data[key] ? 0 : data[key].reduce((a, b) => {
        if (b.score) {
          totalScores += 1;
          return a + b.score;
        }
        return a;
      }, 0);
      let totalInitialScores = 0;
      const initialTotal = !data[key] ? 0 : data[key].reduce((a, b) => {
        if (b.config && Array.isArray(b.config) && b.config.length > 0) {
          const firstConf = b.config[0];
          if (firstConf && firstConf.score) {
            totalInitialScores += 1;
            return firstConf.score + a;
          }
        }
        return a;
      }, 0);
      const getLabel = () => {
        // let label = subSections[key].label.split('&').join('\n&');
        let label = '';
        let cont = '';
        const split = subSections[key].label.split(' ');
        split.forEach(s => {
          if (cont.length >= 10 || `${cont} ${s}`.length > 10) {
            label += `${cont}\n`;
            cont = '';
          }
          if (!cont.length) {
            cont = s;
          } else {
            cont += ` ${s}`;
          }
        });
        if (cont !== '') {
          if (!label.length) {
            label = cont;
          } else {
            label += ` ${cont}`;
          }
        }
        // label = label.split('&').join('\n&');
        if (i === 0) {
          label = label + '\n\n';
        } else if (i === 3) {
          if (label.split('\n').length > 2) {
            const [first, ...rest] = label.split('\n');
            label = `${first}\n ${rest.join('')}`;
          }
          // label = '\n' + label;
        }
        if (label.includes('Environment&')) {
          return 'Environment &\nNatural Resources';
        }
        if (label.includes('Environnement&')) {
          return 'Environnement &\nRessources naturelles';
        }
        return label;
      }
      const it = {
        item: getLabel(),
      };
      it[i18next.t('Current')] = total ? parseFloat((total / totalScores).toFixed(2)) : 0;
      it[i18next.t('Baseline')] = initialTotal ? parseFloat((initialTotal / totalInitialScores).toFixed(2)) : 0;
      items.push(it);
      i++;
      return items;
    }, []);
  }

  const getSubscoreAvg = (subScore) => {
    if (subScore && Object.keys(subScore).filter(key => !subScore[key]).length === 0) {
      const v = Object.values(subScore).reduce((a, b) => {
        return a + b;
      }, 0) / Object.keys(subScore).length;
      return Number.isNaN(v) ? 0 : v;
    }
    return 0;
  }

  const getRiskSubscores = () => {
    const categories = data[subsection];
    if (!data || !categories) return null;
    const category = categories.find(c => c.subCategory === subgroup);
    return category ? category.components : null;
  }

  useEffect(() => {
    setLoadingLinkedEvents(true);
    const fetchData = async () => {
      try {
        const end = moment();
        const start = moment().subtract(12, 'months');
        const startDate = start.format('YYYY-MM-DD');
        const endDate = end.format('YYYY-MM-DD');
        let sId = params.get('sourceId') || sourceId;

        const res = await RiskService.getEvents({
          id: allData.id,
          params: {
            startDate,
            endDate,
            subCategory: subgroup,
            // typeOfEvent: 'incident',
            sourceId: sId !== 'overview' ? sId : undefined,
          },
        });
        setLinkedEvents(res.data || []);
        setLoadingLinkedEvents(false);
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, [subgroup]);

  const getRiskEvents = () => {
    if (subgroup) {
      // we neeed to check this one
      return linkedEvents;
    }
    return [];
  }

  const getPreviewData = () => {
    return (data[subsection] || []).find(d => d.subCategory === subgroup) || {};
  }

  const hasRiskHistory = () => {
    const groupData = (data[subsection] || []).find(d => d.subCategory === subgroup);
    return groupData && groupData.components && groupData.components.vulnerability ? true : false;
  }
  const getTrend = () => {
    const groupData = (data[subsection] || []).find(d => d.subCategory === subgroup);
    // const icon = groupData ? groupData.trend : 'equal';
    // const props = {
    //   up: {
    //     style: { fontSize: '150px' }
    //   },
    //   down: {
    //     style: { fontSize: '150px' }
    //   },
    //   equal: {
    //     rotate: 90,
    //     style: { fontSize: '150px' }
    //   }
    // }
    // return trendIcons[icon] ? <GetIcon icon={trendIcons[icon]} {...props[icon]}/> : null

    if (!groupData?.config) {
      return;
    }

    const coef = 1;
    const config = groupData.config || [];
    const riskData = config.map((c, ind) => {
      return {
        'key': ind + 1,
        'risk': i18next.t('Risk'),
        'date': moment(c.createdAt).format('YYYY-MM-DD HH:mm:ss'),
        'Score': (c.score || 0) * coef
      }
    })
    if (riskData.length === 1) {
      riskData.push({
        'key': riskData.length + 1,
        'risk': i18next.t('Risk'),
        'date': moment().format('YYYY-MM-DD HH:mm:ss'),
        'Score': (groupData.score || 0) * coef
      });
    }
    return riskData;
  }
  const getEvolutionForm = () => {
    if (form && form[subsection]) {
      const category = form[subsection] || {};
      const subCategory = (category.forms || {})[subgroup] || {};
      return subCategory.planning;
    }
    return {};
  }
  // <div className="riskProfile">
  //   <div className="title">
  //     <div>
  //       <GetIcon icon="folder-chart" type="line" />
  //       <h1>{i18next.t('Trend')}</h1>
  //     </div>
  //   </div>
  //   <div className="risk-trend-content">
  //     {getTrend()}
  //   </div>
  // </div>
  const subGroupForm = form[subsection] && form[subsection].forms
    ? (form[subsection].forms[subgroup] || {}) : {};
  const subGroupFormData = getPreviewData();
  const isRiskRelevant = (checkValues = ['yes']) => {
    if (subGroupForm && subGroupForm.identification && subGroupForm.identification.isRiskRelevant) {
      return subGroupFormData && checkValues.includes(subGroupFormData.isRiskRelevant);
    }
    return true;
  }
  const getEvolutionData = () => {
    const groupData = (data[subsection] || []).find(d => d.subCategory === subgroup);
    return groupData ? {
      config: groupData.config,
      updatedAt: groupData.updatedAt,
      score: groupData.score,
      category: groupData.category,
      subCategory: groupData.subCategory,
    } : [];
  }
  const goToForm = (formid) => {
    if (canEdit) {
      let url = match.path;
      // eslint-disable-next-line no-useless-escape
      const r = new RegExp(`\/view\/`);
      const [previous, extra] = url.split(r);
      push(generatePath(`${previous}/edit/${extra}/:formid?`, { ...match.params, group, subsection, subgroup, formid }));
    }
  }

  const evolutionData = getEvolutionData();

  const getRiskScoreDate = () => {
    const data = evolutionData.config;

    if (data) {
      const createdAtDates = data.map((d) => moment(d.createdAt));
      let lastDate = null;
      let completedAtDates = data.map((d) => d.completedAt);
      if (!completedAtDates.includes(undefined)) {
        completedAtDates = completedAtDates.map((d) => moment(d));
        lastDate = moment.max(completedAtDates);
      }
      const maxDate = moment.min(createdAtDates);
      return {
        firstDate: maxDate,
        lastDate,
      };
    }

    return null;
  };

  const goBack = () => {
    push(pathname.split(`/${subgroup}`)[0]);
  };

  const subScore = Number(getSubscoreAvg(getRiskSubscores())).toFixed(1);
  const roundSubScore = Math.round(subScore);
  const subColor = colors[4];

  return (
    <div className="content risk-template" ref={container}>
      {subgroup ? (
        <div className="risk-header-group">
          <div className="risk-header">
            <div className="main">
              <div className="cont">
                <ArrowLeftOutlined
                  onClick={() => goBack()}
                />
              </div>
              <div className="cont">
                <h1>{getSubGroupTitle()}</h1>
              </div>
            </div>
            <div className="score">
              <div className="cont">
                <h1>{i18next.t('Current score')}:</h1>
              </div>
              <div className="cont">
                <div className="number" style={{ background: subColor }}>
                  <span>{subScore}</span>
                </div>
              </div>
              <div className="cont">
                <h4 style={{ color: subColor }}>{getLabels(roundSubScore, (t) => i18next.t(t))}</h4>
              </div>
            </div>
          </div>
          <RiskScore
            key={subgroup ? subgroup : subsection}
            score={getTotalScore()}
            subScore={getRiskSubscores()}
            editDisabled={!isRiskRelevant(['yes', 'no', 'unsure'])}
            onEdit={() => goToForm('assessment')}
            canEdit={canEdit}
            subGroup={subgroup}
            subSection={subsection}
            riskScoreDate={getRiskScoreDate()}
            evolutionData={evolutionData.config}
            isRisk
            isSubGroup
          />
        </div>
      ) : null}
      <div style={{ display: 'flex', gap: 24, marginBottom: 24 }}>
        {!subgroup && (
          <RiskScore
            key={subgroup ? subgroup : subsection}
            score={getTotalScore()}
            subScore={getRiskSubscores()}
            editDisabled={!isRiskRelevant(['yes', 'no', 'unsure'])}
            onEdit={() => goToForm('assessment')}
            canEdit={canEdit}
            subGroup={subgroup}
            subSection={subsection}
            riskScoreDate={getRiskScoreDate()}
            evolutionData={evolutionData.config}
            isRisk
          />
        )}
        {subgroup ? <RiskTrend data={getTrend()} isSubGroup />
          : (
            <RiskProfile
              style={{
                height: '290px',
                width: '99%',
                maxWidth: '99%',
              }}
              showLegend
              type="RISK_PROFILE"
              data={getRiskProfiles()}
              language={user.language}
            />
          )
        }
        <IncidentTimeline
          mod={mod}
          mode={mode}
          isSubGroup={!!subgroup}
          data={linkedEvents}
          loading={loadingLinkedEvents}
        />
      </div>
      {!subgroup ? (
        <div className="wrapper risk-widget risk-categories">
          <h1 className="text-header">{i18next.t('Risk Categories')}</h1>
          <div className="w-100">
            <Tabs
              defaultActiveKey={subsection}
              onChange={(changedTo) => {
                const params = { ...match.params, subsection: changedTo };
                push(generatePath(formPaths.view(mod), params));
              }}
              items={repeatObjects(subSections, (key) => ({
                tabKey: key,
                key: key,
                label: (
                  <span style={{ fontSize: 14 }}>
                    {subSections[key].icon ? <GetIcon
                      icon={subSections[key].icon}
                      type={subSections[key].iconType}
                      style={{ color: subsection === key ? 'var(--color-primary-70)' : '#BDBDBD' }}
                    /> : null}
                    {subSections[key].label ? getInputLabel(subSections[key], data) : key}
                  </span>
                ),
                children: (
                  <Table
                    locale={getLocales(t)}
                    bordered
                    columns={getCols(key)}
                    dataSource={data[key]}
                    pagination={false}
                  >
                  </Table>
                )
              }))}
            >
            </Tabs>
          </div>
        </div >
      ) : (
        <SubGroupView
          canEdit={canEdit}
          subGroupForm={subGroupForm}
          linkingForms={linkingForms}
          subGroupFormData={subGroupFormData}
          linkingData={linkingData}
          goToForm={goToForm}
          subgroup={subgroup}
          subsection={subsection}
          getRiskEvents={getRiskEvents}
          evolutionData={evolutionData}
          getEvolutionForm={getEvolutionForm}
          hasRiskHistory={hasRiskHistory}
          isRiskRelevant={isRiskRelevant}
          location={location}
          participantOrgName={participantOrgName}
        />
      )
      }
    </div >
  );
}

export const Risk = connect(({ authentication, project }) => ({ authentication, project }), null)(RiskComponent);

